(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hype-chair-icons-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hype-chair-tabs').forEach(function (section) {
    var panels = section.querySelectorAll('.hype-chair-tabs__panel');
    if (!panels.length) return;

    function activate(index) {
      // Every panel carries its own copy of the tab bar; update button state
      // across all of them so the active indicator stays correct even on
      // hidden panels (they're revealed by the same click).
      section.querySelectorAll('.hype-chair-tabs__button').forEach(function (btn) {
        var active = btn.getAttribute('data-tab-index') === String(index);
        btn.setAttribute('data-active', active ? 'true' : 'false');
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-tab-index') === String(index);
        if (active) {
          panel.removeAttribute('hidden');
          panel.setAttribute('data-active', 'true');
        } else {
          panel.setAttribute('hidden', '');
          panel.setAttribute('data-active', 'false');
        }
      });

      var activeBtn = section.querySelector('.hype-chair-tabs__button[data-tab-index="' + index + '"]');
      var tabLabel = activeBtn ? (activeBtn.innerText || activeBtn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() : '';
      document.dispatchEvent(new CustomEvent('hype-chair-tab-change', {
        detail: { tabLabel: tabLabel, tabIndex: parseInt(index, 10) }
      }));
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.hype-chair-tabs__button');
      if (!btn || !section.contains(btn)) return;
      activate(btn.getAttribute('data-tab-index'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-collab-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCountdown(el) {
    if (!el) return;
    var endTimeStr = el.getAttribute('data-end-time');
    if (!endTimeStr) return;
    var endTime = new Date(endTimeStr).getTime();
    if (isNaN(endTime)) return;

    var dayEl = el.querySelector('[data-unit="d"]');
    var hourEl = el.querySelector('[data-unit="h"]');
    var minEl = el.querySelector('[data-unit="m"]');

    function update() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        el.style.display = 'none';
        return false;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      if (dayEl) dayEl.textContent = days + 'd';
      if (hourEl) hourEl.textContent = hours + 'h';
      if (minEl) minEl.textContent = mins + 'm';
      return true;
    }

    if (update()) {
      var interval = setInterval(function () {
        if (!update()) clearInterval(interval);
      }, 60000);
    }
  }

  document
    .querySelectorAll('.hype-collab-hero[data-display-mode="countdown"] .hype-collab-hero__countdown')
    .forEach(initCountdown);

  function initMascotParallax(hero) {
    var mascot = hero.querySelector('.hype-collab-hero__mascot');
    if (!mascot) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = 0.5;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var scrolledPast = Math.max(0, -rect.top);
      if (scrolledPast === 0) {
        mascot.style.transform = '';
        return;
      }
      var offset = Math.min(scrolledPast * speed, rect.height);
      mascot.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    mascot.style.willChange = 'transform';
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  document.querySelectorAll('.hype-collab-hero').forEach(initMascotParallax);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-collab-video-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var items = document.querySelectorAll('.hype-collab-video-highlights__item');
    if (!items.length) return;

    items.forEach(function (item, i) {
      item.style.setProperty('--reveal-index', i);
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

    items.forEach(function (item) { observer.observe(item); });
  })();

  } catch(e) { console.error(e); }
})();
})();
